var mutation = {

	 //单个设置个人信息
	 setuserinfo(state,{data,key}){
	 	state['userinfo'][key] = data;
	 },
	// 设置个人信息
	setData(state,payload) {
		state.userinfo = payload;
	},
}
export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/user/mutation.js